import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgProgressModule, NgProgressBrowserXhr } from 'ngx-progressbar';
import { BrowserXhr } from '@angular/http';

import { AppComponent } from './app.component';
import{ DataService } from './services/data.service';
import{ HttpModule } from '@angular/http';
import{ RouterModule, Routes } from '@angular/router';

import { CategoriesComponent } from './components/categories/categories.component';
import { EmailsComponent } from './components/emails/emails.component';
import { SafePipe } from './utility/safe.pipe';
import { DemosComponent } from './components/demos/demos.component';
import { GlobalsComponent } from './components/globals/globals.component';
import { AvatarsComponent } from './components/avatars/avatars.component';
import { PlayboyComponent } from './components/playboy/playboy.component';
import { BannersComponent } from './components/banners/banners.component';
import { MicrowebsitesComponent } from './components/microwebsites/microwebsites.component';
import { DatavisualizationsComponent } from './components/datavisualizations/datavisualizations.component';
import { VideocontrolComponent } from './components/videocontrol/videocontrol.component';
import { SystemsComponent } from './components/systems/systems.component';
import { MiscellaneousComponent } from './components/miscellaneous/miscellaneous.component';
import { InstructionalComponent } from './components/instructional/instructional.component';
import { NonnativeappsComponent } from './components/nonnativeapps/nonnativeapps.component';
import { NativeappsComponent } from './components/nativeapps/nativeapps.component';
import { SocialmediaComponent } from './components/socialmedia/socialmedia.component';
import { EventkioskComponent } from './components/eventkiosk/eventkiosk.component';
import { InstorekioskComponent } from './components/instorekiosk/instorekiosk.component';
import { JobpositionsComponent } from './components/jobpositions/jobpositions.component';
import { DocumentationComponent } from './components/documentation/documentation.component';

const appRoutes: Routes=[
{path:'',component:CategoriesComponent},
{path:'categories',component:CategoriesComponent},
{path: 'emails', component:EmailsComponent},
{path: 'demos',component:DemosComponent},
{path: 'banners',component:BannersComponent},
{path: 'datavisual',component:DatavisualizationsComponent},
{path: 'video',component:VideocontrolComponent},
{path: 'playboy',component:PlayboyComponent},
{path: 'microsites',component:MicrowebsitesComponent},
{path: 'systems',component:SystemsComponent},
{path: 'misc',component:MiscellaneousComponent},
{path: 'instruction',component:InstructionalComponent},
{path: 'nonnative',component:NonnativeappsComponent},
{path: 'nativeapps',component:NativeappsComponent},
{path: 'socialmedia',component:SocialmediaComponent},
{path: 'eventkiosk',component:EventkioskComponent},
{path: 'instorekiosk',component:InstorekioskComponent},
{path: 'jobpositions',component:JobpositionsComponent},
{path: 'avatars',component:AvatarsComponent},
{path: 'documentation',component:DocumentationComponent}

]

@NgModule({
  declarations: [
    AppComponent,
    CategoriesComponent,
    EmailsComponent,
    SafePipe,
    DemosComponent,
    GlobalsComponent,
    AvatarsComponent,
    PlayboyComponent,
    BannersComponent,
    MicrowebsitesComponent,
    DatavisualizationsComponent,
    VideocontrolComponent,
    SystemsComponent,
    MiscellaneousComponent,
    InstructionalComponent,
    NonnativeappsComponent,
    NativeappsComponent,
    SocialmediaComponent,
    EventkioskComponent,
    InstorekioskComponent,
    JobpositionsComponent,
    DocumentationComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    RouterModule.forRoot(appRoutes,{useHash: true}),
    NgProgressModule
  ],
  providers: [DataService, GlobalsComponent, {provide: BrowserXhr, useClass: NgProgressBrowserXhr}],
  bootstrap: [AppComponent]
})
export class AppModule {
public progressService: NgProgressModule
private http:HttpModule;


}



// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/app.module.ts